var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"o-polaroid"},[_c('div',{staticClass:"tape-l"}),_c('div',{staticClass:"tape-r"}),_c('img',{attrs:{"src":_vm.src}})])}
var staticRenderFns = []

export { render, staticRenderFns }